import React, {useState, useEffect} from "react";
import SliderSection from "./SliderSection";
import TagsSection from "./TagsSection";
import axios from "axios";
import querystring from "querystring";
const ImagePageApp = ({searchImageText, newImageInput, Modal, sessionData}) => {
  const [imageName, setImageName] = useState(
    searchImageText !== undefined && searchImageText !== "" && searchImageText !== null
      ? searchImageText
      : newImageInput
  );
  const [imageData, setImageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [like, setLike] = useState(false);

  useEffect(() => {
    getimageData();
  }, []);
  

  useEffect(() => {
    if (imageData?.data?.imageData?.tag_id) {
      getTags(imageData.data.imageData.tag_id);
    }
  }, [imageData]);
  
  
  const setParams = (text) => {
    history.pushState({}, "", "image-page?imageText=" + text);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  // const getimageData = (newUrl) => {
  //   setLoading(true);
  //   let url;
  //   if (!newUrl) {
  //     url = `https://api.bookeventz.com/imageTags/getImageAttachementDetails?image_name=${imageName}`;
  //   } else {
  //     url = newUrl;
  //   }
  //   try {
  //     axios.get(url).then((res) => {
  //       setImageData(res.data);
  //       setLoading(false);
  //     });
  //     return res.data;
  //   } catch (err) {
  //     console.log(err, "error");
  //   }
  // };
  // const getTags = () => {
  //   let url = `https://api.bookeventz.com/ImageTags/getTagList?if_active=1`;
  //   try {
  //     axios.get(url).then((res) => {
  //       setTags(res.data);
  //     });
  //   } catch (err) {
  //     console.log(err, "error");
  //   }
  // };

  const getimageData = async (newUrl) => {
    setLoading(true);
    let url = newUrl || `https://api.bookeventz.com/imageTags/getImageAttachementDetails?image_name=${imageName}`;
  
    try {
      const res = await axios.get(url);
      setImageData(res.data);
      return res.data; 
    } catch (err) {
      console.log(err, "error");
    } finally {
      setLoading(false);
    }
  };
  


  const getTags = async (tagId) => {
    if (!tagId || tagId == 0) {
      setTags([]);
    }
  
    const url = `https://api.bookeventz.com/ImageTags/getTagList?if_active=1&id=${tagId}`;
    
    try {
      const res = await axios.get(url);
      setTags(res.data);
    } catch (err) {
      console.error("Error fetching tags:", err);
    }
  };
  
  const saveSingleImage = (imageId) => {
    let url = `https://api.bookeventz.com/ImageTags/insertImageWihoutAlbum`;
    let formData = {
      user_profile_id: sessionData?.user_profile_id,
      image_attachment_id: imageId,
      if_active: 1,
    };
    try {
      axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
        if (formUpdate.data?.success == true) {
          setLike(true);
        }
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  return (
    <>
      <div id="image-page-main-wrapper">
        <SliderSection
          imageData={imageData}
          loading={loading}
          getimageData={getimageData}
          Modal={Modal}
        />
        <TagsSection
          imagesData={imageData}
          tags={tags}
          setParams={setParams}
          searchImageText={imageName}
          saveSingleImage={saveSingleImage}
          getimageData={getimageData}
          like={like}
        />
      </div>
    </>
  );
};

export default ImagePageApp;
